/* eslint-disable no-undef */
import styled from 'styled-components';
import bg from '../assets/img/topbar/background.png';

const LayoutsStyled = styled.div`
  display: flex;
  /* z-index: 1;
  position: absolute; */
  .header {
    background-color: transparent;
    background-image: url(${bg});
    /* background-color: rgba(51, 121, 200, 1); */
    z-index: ${(props) => props.theme.zIndex.drawer + 1};
    .title {
      flex-grow: 1;
      color: #fff;
    }
    .menuButton {
      margin-right: ${(props) => props.theme.spacing(2)};
    }
    .hide {
      display: 'none';
    }
  }
  .sideNav {
    width: ${(props) => props.drawerWidth}px;
    height: 100vh;
    flex-shrink: 0;

    .MuiDrawer-paper {
      width: ${(props) => props.drawerWidth}px;
      border-right: 0;
    }

    .drawerContainer {
      width: ${(props) => props.drawerWidth}px;
      overflow: auto;

      .nested {
        padding-left: ${(props) => props.theme.spacing(4)};
      }

      .MuiCollapse-container {
        width: 100%;
      }
      .scrollbar-container {
        margin-top: 8px;
      }
    }
  }

  .sideNav-hidd {
    display: none;
    width: ${(props) => (props.drawerWidth === 0 ? 256 : 0)};
    /* display: none; */
  }

  @media screen and (max-width: 1440px) {
    .sideNav-hidd {
      display: block;
    }
    .sideNav {
      display: none;
    }
  }

  .content {
    display: flex;
    flex-flow: column nowrap;
    flex-grow: 1;
    /* justify-content: ${(props) =>
      !props.isContentPage ? 'center' : 'flex-start'}; */
    margin-top: ${(props) => (!props.isContentPage ? 0 : '56px')};
    padding: ${(props) => (!props.isContentPage ? 0 : '0 12px 12px 12px')};
    /* height: ${(props) =>
      !props.isContentPage ? '100%' : 'calc(100vh - 56px)'}; */
    @media screen and (max-height: 900px) {
      height: ${(props) =>
        !props.isContentPage ? '100%' : 'calc(100vh - 56px)'};
    }
    @media screen and (min-height: 900px) {
      height: ${(props) =>
        !props.isContentPage ? '100vh' : 'calc(100vh - 56px)'};
    }
    /* min-width: calc(1680px - 256px - 24px); */
    /* min-height: calc(900px - 56px - 20px); */
    overflow: auto;
    background-color: #f5f5f5;
    background: center 100% / 100% 100% no-repeat
      url(${(props) =>
        !props.isContentPage
          ? ''
          : props.brandThemes[props.brand].content.bgImg});
    .breadbar {
      height: 100px;
    }
    .content-inner-wapper {
      display: flex;
      flex-direction: column;
      padding: 12px;
      /* height: ${(props) =>
        props.isOutContent ? 'auto' : 'calc(100vh - 56px)'}; */
      @media screen and (min-height: ${(props) => props.contentInnerHeight}px) {
        height: calc(100vh - 56px);
      }
    }
  }
  .padding0 {
    padding: 0;
    background-color: rgb(228, 228, 228);
  }

  /* 设置首页管理nav样式 */
  .homepage-nav {
    .MuiButton-label {
      .icon {
        color: #212121;
      }
      .title {
        font-weight: 900;
        color: #212121;
        padding-left: 8px;
      }
    }
    .active {
      .MuiButton-label {
        .icon {
          color: #ffffff;
        }
        .title {
          font-weight: 900;
          color: #ffffff;
          padding-left: 8px;
        }
      }
    }
  }
`;
export { LayoutsStyled };
